<template>
	<div>
		<div v-if="cont" class="selected-tickets mt-0">
	        <label style="text-transform: uppercase">{{ $t('evento.entradas_seleccionadas') }}:</label>
	        <ul>
		        <template v-for="(entrada, index) in entradas">
		            <li :key="index" v-if="entrada.unidades > 0">
		                {{ ++index }}. {{ entrada.name }} x{{ entrada.unidades }}
		            </li>
		        </template>
	        </ul>
	        <div>
	        	<button class="button large-button effect-button" @click.prevent="continuar" :disabled="!paso_activo"><span>{{ $t('partido.continuar_compra') }}</span></button>
			</div>
		</div>
    </div>
</template>

<script>
export default {
    props: ['entradas', 'siguiente', 'paso_activo'],
    data() {
        return {
        }
    },
    computed: {
        cont() {
            var cont = false;
            for(var i in this.entradas) {
                if(this.entradas[i].unidades > 0) {
                    cont = true;
                }
            }

            return cont;
        },
        footer() {
            return this.$store.getters.getFooter;
        },
    },
    methods: {
        continuar() {
            this.$emit('continuar');
        }
    },
}
</script>

<style>

</style>
